module.exports = __webpack_public_path__ + "certificate.14b95c7efcca6f7f08f6cfc06c4e785b.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/variables/certificate.png
// module id = 7587281253955536
// module chunks = 1